import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { routePaths } from '../../common/routing/routePaths'

export function useInitChat() {
  const navigate = useNavigate()

  return useCallback(() => {
    navigate(routePaths.init)
  }, [navigate])
}
